"use client";

import React from "react";
import { withRef } from "@udecode/cn";
import { useEditorRef } from "@udecode/plate-common";
import { Icons } from "../icons/icons";

import { ToolbarButton } from "./Toolbar";
import { insertColumnGroup } from "@udecode/plate-layout";

// @ts-ignore
export const ColumnToolbarButton = withRef<typeof ToolbarButton>(
	(rest, ref) => {
		const editor = useEditorRef();
		const { props } = {
			props: {
				onClick() {
					insertColumnGroup(editor as any);
				},
			},
		};

		return (
			<ToolbarButton ref={ref} tooltip="Columns" {...props} {...rest}>
				<Icons.LayoutIcon />
			</ToolbarButton>
		);
	}
);
